import {getSlowQueryRequest, getSlowQueryDbRequest, getCdnConfigAll,handleCdnConfigAll,getCountryCodeAll,handleDevopsApi,deleteCdnConfigAll,getCdnApp} from "../../../api/api";
import {getUrl} from "../../../utils/global/geturl";
import ajax from "../../../api/ajax"

/*
  设置这个接口下的超时时间
 */

const  state = {

};

const getters = {

};

const mutations = {

};

const actions = {
  async getSlowQueryMethod ({commit}, params) {
    return getSlowQueryRequest(getUrl(params)).then(response => response)
  },
  async getSlowQueryDbMethod ({commit}, params) {
    return getSlowQueryDbRequest(getUrl(params)).then(response => response)
  },
  async getCdnConfigMethod({commit},params){
    return getCdnConfigAll(getUrl(params)).then(response => response)
  },
  async reqCdnConfigAllMethod({commit},params){
    return handleCdnConfigAll(params).then(response => response)
  },
  async delCdnConfigAllMethod({commit},params){
    return deleteCdnConfigAll(getUrl(params)).then(response => response)
  },
  async getCdnCountryCodeMethod ({commit}, params) {
    return getCountryCodeAll(getUrl(params)).then(response => response)
  },
  async reqDevopsApi({commit},params){
    return handleDevopsApi(params).then(response => response)
  },
  async getCdnAppMethod({commit},params){
    return getCdnApp(getUrl(params)).then(response => response)
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/slowquery/slowquery.js